import { jsx, Fragment, jsxs } from "react/jsx-runtime";
import { c } from "react/compiler-runtime";
import MuiTableCell from "@mui/material/TableCell";
import MuiTableRow from "@mui/material/TableRow";
import MuiTableFooter from "@mui/material/TableFooter";
import Typography from "@mui/material/Typography";
import Tooltip from "@mui/material/Tooltip";
import { formatValue } from "../utils/data.js";
import { formatDateTime } from "../utils/date.js";
import CellWithTrend from "./CellWithTrend.js";
const TableBody = (t0) => {
  const $ = c(7);
  const {
    data,
    isLoading: t1,
    columns
  } = t0;
  const isLoading = t1 === void 0 ? false : t1;
  if (!data || isLoading) {
    return null;
  }
  const {
    columns: columnsData,
    data: summary
  } = data;
  let t2;
  if ($[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      position: "sticky",
      bottom: 0
    };
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] !== columns || $[2] !== columnsData || $[3] !== summary) {
    t3 = columns.map((col, colIndex) => {
      if (colIndex === 0) {
        return /* @__PURE__ */ jsx(MuiTableCell, { children: /* @__PURE__ */ jsx(Fragment, { children: "Total" }) }, "tf-summary-total");
      }
      const {
        type,
        comparison
      } = col;
      const columnDataIndex = columnsData?.findIndex((column) => column.key === col.value.key);
      if (columnDataIndex === -1) {
        return /* @__PURE__ */ jsx(MuiTableCell, {}, `tf-summary-${colIndex}`);
      }
      const columnData = columnsData[columnDataIndex];
      if (!columnData) {
        return /* @__PURE__ */ jsx(MuiTableCell, {}, `tf-summary-${colIndex}`);
      }
      const columnType = columnData.type;
      const numeric = columnType !== "string" && columnType !== "boolean" && columnType !== "icon" || comparison !== void 0;
      return /* @__PURE__ */ jsxs(MuiTableCell, { align: numeric ? "right" : "left", sx: {
        whiteSpace: "nowrap",
        border: "none",
        boxShadow: "none",
        textAlign: columnType === "string" ? "left" : "right"
      }, children: [
        columnType !== "string" && columnType !== "boolean" && columnType !== "duration" && columnType !== "icon" && columnType !== "link" && !comparison && (() => {
          const {
            format
          } = col;
          const formatOptions = {
            type: columnType,
            short: columnData.short === false ? false : true,
            precision: columnData.precision ?? (type !== "integer" ? 2 : 0),
            currency: columnData.currency,
            ...format
          };
          const tooltipValue = formatValue(summary[0]?.[columnDataIndex], {
            ...formatOptions,
            short: false
          });
          const summaryValue = formatValue(summary[0]?.[columnDataIndex], formatOptions);
          return /* @__PURE__ */ jsx(Tooltip, { placement: "top", title: tooltipValue, children: /* @__PURE__ */ jsx(Typography, { variant: "valueSummary", children: summaryValue }) });
        })(),
        columnType !== "string" && columnType === "duration" && !comparison && (() => {
          const {
            display_format: display
          } = col;
          const durationValue = formatDateTime({
            value: Math.trunc(summary[0]?.[columnDataIndex]),
            type: columnType,
            display
          });
          return /* @__PURE__ */ jsx(Tooltip, { placement: "top", title: durationValue, children: /* @__PURE__ */ jsx(Typography, { variant: "valueSummary", children: durationValue }) });
        })(),
        columnType === "string" && /* @__PURE__ */ jsx(Fragment, { children: summary[0]?.[columnDataIndex] }),
        comparison && (() => {
          const columnConfig = columns[colIndex];
          const keyToCompare = columnConfig.comparison.key;
          const keyToValue = columnConfig.value.key;
          const valueToCompare = summary[0]?.[columnsData.findIndex((col_0) => col_0.key === keyToCompare)];
          const value = summary[0]?.[columnsData.findIndex((col_1) => col_1.key === keyToValue)];
          return valueToCompare !== void 0 ? /* @__PURE__ */ jsx(CellWithTrend, { value, comparison: valueToCompare, desiredTrend: columnConfig.desired_trend ?? "positive" }) : null;
        })()
      ] }, `tf-summary-${colIndex}`);
    });
    $[1] = columns;
    $[2] = columnsData;
    $[3] = summary;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t3) {
    t4 = /* @__PURE__ */ jsx(MuiTableFooter, { children: /* @__PURE__ */ jsx(MuiTableRow, { sx: t2, children: t3 }, "summary") });
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  return t4;
};
export {
  TableBody as default
};
